import { useNavigate, useLocation } from "react-router-dom";
import { Home, Calendar, MessageCircle, Bell, User, Video } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { cn } from "@/lib/utils";

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { strings } = useLanguage();

  const navItems = [
    { path: "/promo-videos", icon: Video, label: strings.promoVideos },
    { path: "/today", icon: Home, label: strings.todayLesson },
    { path: "/upcoming", icon: Calendar, label: strings.upcoming },
    { path: "/chat", icon: MessageCircle, label: strings.chatWith },
    { path: "/profile", icon: User, label: strings.profile },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border z-50 safe-area-bottom">
      <div className="container mx-auto px-2">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className={cn(
                  "flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-colors min-w-[60px]",
                  isActive
                    ? "text-primary bg-primary/10"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted"
                )}
              >
                <Icon className={cn("w-6 h-6", isActive && "scale-110")} />
                <span className="text-xs font-medium line-clamp-1">{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
